import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffInbox = () => import('./staff/inbox')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'MessagesStaffDashboard',
  inbox: 'MessagesStaffInbox',
}

const router =
  [
    {
      path: '/st/messages',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mensajería Interna',
          }
        },
        {
          path: 'inbox/:conversationId?',
          name: VIEWS.inbox,
          component: ViewStaffInbox,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Bandeja de Mensajes',
          }
        },
      ]
    },

    {
      path: '/cu/messages',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/messages',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
